import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AfasFunction } from '../classes/afas-function.class';
import { ApiService } from './api/api.service';

@Injectable({
    providedIn: 'root',
})
export class AfasFunctionService {
    private readonly endpoint = 'afas-functions';
    private apiService: ApiService = inject(ApiService);

    /**
     * Get all AFAS functions with their roles
     */
    getList(): Observable<AfasFunction[]> {
        return this.apiService.getCallData$<AfasFunction[]>(this.endpoint);
    }

    /**
     * Save roles for a function
     */
    saveRoles(functionKey: string, roleKeys: string[]): Observable<any> {
        return this.apiService.postCall$(`${this.endpoint}/${functionKey}`, { role_keys: roleKeys });
    }
}
